<template>
  <div v-if="categoryYears">
    <h1>Category Year</h1>
    <table border="1" class="categoryYear">
      <tr>
        <td />
        <th
          v-for="(categoryCount, countIndex) in categoryYears.categoryCount"
          :key="countIndex"
        >{{categoryCount.category.code}}</th>
        <td />
      </tr>
      <tr v-for="(categoryYear, yearIndex) in categoryYears.categoryYear" :key="yearIndex">
        <th>{{categoryYear.year}}</th>
        <td
          v-for="(categoryCount, categoryCountIndex) in categoryYear.categoryCount"
          :key="categoryCountIndex"
        >
          <span v-if="categoryCount.count > 0">{{categoryCount.count}}</span>
        </td>
        <td>
          <span v-if="categoryYear.count > 0">{{categoryYear.count}}</span>
        </td>
      </tr>
      <tr>
        <td />
        <td
          v-for="(categoryCount, countIndex) in categoryYears.categoryCount"
          :key="countIndex"
        >{{categoryCount.count}}</td>
        <td>{{categoryYears.count}}</td>
      </tr>
    </table>
    <div v-for="(categoryCount, countIndex) in categoryYears.categoryCount" :key="countIndex">
      {{categoryCount.category.code}}
      <span>&#160;-&#160;</span>
      {{categoryCount.category.name}}
    </div>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "CategoryYear",
  metaInfo() {
    return {
      title: "Category year",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return { categoryYears: null };
  },
  methods: {
    fetchCategoryYears() {
      nbmlaw.get(`/cors/admin/file/categories/years`).then(response => {
        // console.log(response.data);
        this.categoryYears = response.data;
      });
    }
  },
  created() {
    this.fetchCategoryYears();
  }
};
</script>

<style>
</style>
